
    import { Observable } from 'rxjs';
    import { UseCase } from '../../base/use-case';
    import { InvoiceModel } from '../../models/configuration/invoice.model';
    import { ConfigurationRepository } from '../../repositories/configuration.repository';
    import { InvoiceResponseModel } from '../../models/configuration/invoice-response.model';
    import { InvoiceEntity } from '../../../data/repositories/configuration/entities/invoice.entity';
     
    export class GetInvoiceUseCase implements UseCase<InvoiceModel, InvoiceResponseModel> {
            constructor(private config: ConfigurationRepository) { }
            execute(
                 params: InvoiceEntity,
            ): Observable<InvoiceResponseModel> {
            return this.config.getInvoiceAll(params);
        }
    }
